import { isTouchDevice } from '../functions'

// eslint-disable-next-line no-undef
const object = vnObject

const viewportHandler = (el) => {
  if (!el || !isTouchDevice) return

  const viewport = window.visualViewport
  const offsetTop =
    viewport.height - el.getBoundingClientRect().height + viewport.offsetTop

  el.style.setProperty('--offset-top', `${offsetTop}px`)
}

let closer
const globalAlgoliaComplete = document.querySelector(
  '.global-algolia-autocomplete'
)
const autocompleteResults = document.querySelector(
  '.algolia-autocomplete__results'
)
const algoliaAutocomplete = document.querySelector(
  '.algolia-autocomplete-wrapper'
)
if (algoliaAutocomplete) {
  closer = algoliaAutocomplete.querySelector(
    '.algolia-autocomplete-wrapper__closer'
  )
}

const setResultsHeight = () => {
  if (!algoliaAutocomplete) return

  const rect = algoliaAutocomplete.getBoundingClientRect()
  const bottomOffset = window.innerHeight - (rect.top + rect.height)

  algoliaAutocomplete.style.setProperty('--bottom-space', `${bottomOffset}px`)
}

window.addEventListener('resize', setResultsHeight)
window.addEventListener('load', setResultsHeight)

const open = () => {
  if (globalAlgoliaComplete) {
    globalAlgoliaComplete.style.display = 'block'
  }

  if (autocompleteResults) {
    autocompleteResults.style.display = 'block'
  }

  if (algoliaAutocomplete) {
    algoliaAutocomplete.classList.add('algolia-autocomplete-wrapper--focused')

    if (window.matchMedia('(max-width: 991.98px)').matches) {
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
      document.body.classList.add('algolia-mobile-searching')
    }
  }
}

const close = () => {
  algoliaAutocomplete.classList.remove('algolia-autocomplete-wrapper--focused')
  document.body.style.overflow = ''
  document.documentElement.style.overflow = ''
  document.body.classList.remove('algolia-mobile-searching')
  autocompleteResults.style.display = ''

  if (globalAlgoliaComplete) {
    globalAlgoliaComplete.style.display = ''
  }
}

const searchBox = (renderOptions, isFirstRender) => {
  const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions
  const container = widgetParams.container

  if (isFirstRender) {
    const input = document.createElement('input')
    input.type = 'search'
    input.placeholder = widgetParams.placeholder

    container.insertAdjacentHTML('beforeend', object.loader)

    const reset = document.createElement('button')
    reset.type = 'reset'
    reset.insertAdjacentHTML('beforeend', '<i class="vn-icons-close"></i>')

    const submit = document.createElement('button')
    submit.type = 'submit'
    submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>')

    window.visualViewport.addEventListener('scroll', () => {
      viewportHandler(algoliaAutocomplete)
    })
    window.visualViewport.addEventListener('resize', () => {
      viewportHandler(algoliaAutocomplete)
    })

    if (closer) {
      closer.addEventListener('click', close)
    }

    input.addEventListener('focus', open)

    if (algoliaAutocomplete) {
      document.addEventListener('click', (event) => {
        if (window.matchMedia('(min-width: 992px)').matches) {
          const withinBoundaries = event
            .composedPath()
            .includes(algoliaAutocomplete)

          if (!withinBoundaries) {
            close()
          }
        }
      })
    }

    input.addEventListener('input', (training) => {
      refine(training.target.value)
    })

    reset.addEventListener('click', () => {
      clear()
    })

    container.appendChild(input)
    container.appendChild(reset)
    container.appendChild(submit)
  }

  container.querySelector('input').value = query
  container.querySelector('.vn-loader').hidden = !isSearchStalled
  container.querySelector('button[type="reset"]').hidden =
    isSearchStalled || !query
  container.querySelector('button[type="submit"]').hidden =
    isSearchStalled || query
}

const headerSearch = document.querySelector('.header-buttons__search')
if (headerSearch) {
  headerSearch.addEventListener('click', (e) => {
    if (window.matchMedia('(max-width: 991.98px)').matches) {
      e.preventDefault()
      open()
      algoliaAutocomplete.querySelector('input[type=search]').focus()
    }
  })
}

export default searchBox
